module.exports = __webpack_public_path__ + "static/media/Remision.0b647dcb.svg";